import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Beach from '../../components/Cards/beach';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import beachImage from './images/fiPines.jpg';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | F.I. Pines"
      meta={[
        { name: 'description', content: '' },
        { name: 'keywords', content: 'F.I. Pines, Pines, Fire Island, Ferries, New York, Long Island, Water Taxi' },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="F.I. Pines">
        <h2>Communities</h2>
        <h1>F.I. Pines</h1>
        <p>Amenities</p>
        <div className="amenities">
          { Amenities.byBeach('F.I. Pines').map(item => (
            <i key={item.text} className={`icon-${item.icon}`} title={item.text} />
          ))}
        </div>
        <div>
          <Link className="btn btn-outline-light" to="http://www.sayvilleferry.com/">Schedules</Link>
          &nbsp;&nbsp;
          <Link className="btn btn-outline-light" to="/directory">Directory</Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About F.I. Pines</h1>
          </div>
          <p>
            The Fire Island Pines is filled with architecturally breathtaking houses tucked behind well-manicured hedge ways.  
            Upon arrival, visitors discover the town’s gorgeous harbor of 85 boat slips, and its commercial district, just steps away.  
            The superb shops and restaurants have people from all over the island flocking to the Pines.
          </p>
          <p>
            Like Cherry Grove, the Fire Island Pines is a beach escape for members of the LGBTQ+ community looking to leave behind the stresses of city life.  
            Throughout the summer, there are several events unique to this community, such as the annual Invasion on July 4th where drag queens “invade” from the neighboring Cherry Grove.  
            Another incredible event to attend is the Fire Island Dance Festival which raises money for Broadway Cares/ Equity fights AIDS.  
          </p>
        </div>
        <div className="col-xl-4">
          <Beach image={beachImage} link="/communities/sailors-haven" beach="F.I. Pines" description="A beach escape from city life offering many shops and restaurants." className="mx-auto" />
        </div>
      </div>
      <Tip title="Captain's Tip">
        If you are joining in the fun at Invasion be careful of your feet.  You never know when someone may accidently trip in heels.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from the Pines is available by <Link to="http://www.sayvilleferry.com/">Sayville Ferry</Link> located in Sayville, NY.
      </p>
      <p>
        <a href="http://www.fireislandwatertaxi.com">Water Taxi</a> service is available to and from the Pines during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
